<template>
    <vrm-header-panel
        :open="open"
        class="vrm-togglable-panel--inside--outside-header vrm-togglable-panel--search"
    >
        <div class="container">
            <div class="row">
                <div class="col-xs-12">
                    <div class="vrm-search vrm-search--header">
                        <span class="sg-vrm-icon_040_search-16px vrm-search__icon" />
                        <input
                            v-model="model"
                            v-focus
                            type="text"
                            class="sg-element vrm-search__input needsclick"
                            v-bind="$attrs"
                        />
                    </div>
                </div>
            </div>
        </div>
    </vrm-header-panel>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import VrmHeaderPanel from '@/vue/components/layout/VrmHeaderPanel';

@Component({
    components: { VrmHeaderPanel },
    inheritAttrs: false,
})
export default class VrmHeaderSearchPanel extends Vue {
    @Prop()
    open;
    @Model('input')
    value;

    get model() {
        return this.value;
    }

    set model(value) {
        this.$emit('input', value);
    }
}
</script>
